exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-info {\n    position: absolute;\n    bottom: 26px;\n    left: 0;\n    right: 0;\n    padding-top: 10px;\n    padding-right: 15px;\n    padding-bottom: 10px;\n    padding-left: 17px;\n    height: 28px;\n    background: #fff;\n}\n\n.user-info--link {\n    font-size: 14px;\n    color: #000;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    text-decoration: none;\n}\n\n.user-info--link:hover {\n    color: #542376;\n}\n\n.user-info--link:hover .user-info--icon{\n    fill: #542376!important;\n}\n\n.user-info--name {\n    max-width: 130px;\n    margin-left: 25px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/userInfo/userInfo.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/userInfo/userInfo.css
// module chunks = 0